module.exports = __webpack_public_path__ + "img/hardware7.2dac31e8.jpg";